import modelBaseV2 from "../model-base-v2.model";

/**
 * Pop up Management Model
 * 
 * This feature is for admin broadcast an announcement for web user.
 * 
 * @author Molly Liu
 */

const popupModel = {
  getPopupList: (params) => {
    return modelBaseV2.get('/api/webnotice/popup/list', { params });
  },
  updatePopupNotice: (body, popupId) => {
    return modelBaseV2.put(`/api/webnotice/popup/${popupId}`, { body });
  },
  savePopupNotice: (body) => {
    return modelBaseV2.post('/api/webnotice/popup', { body });
  },
  getPopupNoticeDetail: (params) => {
    return modelBaseV2.get('/api/webnotice/popup/detail', { params });
  },
  getPopupNotices: () => {
    return modelBaseV2.get('/api/webnotice/popup/notice');
  }
}

export default popupModel;
